<template>
  <SeoPage page-key="sitiInternetProfessionaliBellinzona" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'SitiInternetProfessionaliBellinzonaPage'
})
</script>

